import { DefaultQueryParams } from '@frontend/api-utils';

export enum ChartBinSize {
    DAY = 'day',
    HOUR = 'hour',
    MONTH = 'month',
    FULL_PERIOD = 'full_period'
}

export enum ChartGroupByMode {
    /** One series per distinct field value (e.g. transaction state). */
    VALUE = 'value',
    /** Two series: field filled in vs empty (e.g. purchase order present or not). */
    PRESENCE = 'presence'
}

export enum ChartQueryParam {
    APPLICATION = 'application',
    FEATURE = 'feature',
    BIN_SIZE = 'bin_size',
    GROUP_BY = 'group_by',
    GROUP_BY_MODE = 'group_by_mode',
    STATE = 'state',
    SLOT_DIMENSION = 'slot_dimension',
    SPOT_ID = 'spot_id',
    MODULE_ID = 'module_id',
    PRODUCT_ID = 'product_id',
    EQUIPMENT_ID = 'equipment_id',
    USER_ID = 'user_id',
    SENDER = 'sender',
    RECEIVER = 'receiver',
    TYPE = 'type',
    BRAND = 'brand',
    NAME = 'name',
    STATUS = 'status',
    DATA_MODE = 'data_mode',
    SORT_DIRECTION = 'sort_direction',
    RETURN_REASON = 'return_reason'
}

export enum ChartDataMode {
    PERCENTAGE = 'percentage'
}

export enum ChartTimerStatus {
    STARTED = 'started',
    COMPLETED = 'completed'
}

export enum ChartTimerName {
    TRANSACTION_DROP_OFF_PENDING = 'transaction_drop_off_pending',
    TRANSACTION_PICK_UP_PENDING = 'transaction_pick_up_pending',
    PACKAGE_AUDIT_PENDING = 'package_audit_pending'
}

export type ChartQueryParams = DefaultQueryParams | ChartQueryParam;
